module.exports = __webpack_public_path__ + "static/media/07-chs.f4b219a3.png";